import React from "react";
import { NavLink, Link } from "react-router-dom";

const NAV_ITEMS = [
  {
    label: "Dashboard",
    to: "/admin",
    end: true,
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="7" height="7" rx="1.5" />
        <rect x="14" y="3" width="7" height="7" rx="1.5" />
        <rect x="14" y="14" width="7" height="7" rx="1.5" />
        <rect x="3" y="14" width="7" height="7" rx="1.5" />
      </svg>
    ),
  },
  {
    label: "Articles",
    to: "/admin/articles",
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 19.5V4.8A1.8 1.8 0 0 1 5.8 3h10.4L20 6.8V19.5A1.5 1.5 0 0 1 18.5 21h-13A1.5 1.5 0 0 1 4 19.5Z" />
        <path d="M14 3v4h4" />
        <path d="M8 10h8" />
        <path d="M8 14h8" />
      </svg>
    ),
  },
  {
    label: "Categories",
    to: "/admin/categories",
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 6.5A2.5 2.5 0 0 1 6.5 4h2A2.5 2.5 0 0 1 11 6.5v2A2.5 2.5 0 0 1 8.5 11h-2A2.5 2.5 0 0 1 4 8.5v-2Z" />
        <path d="M13 6.5A2.5 2.5 0 0 1 15.5 4h2A2.5 2.5 0 0 1 20 6.5v2A2.5 2.5 0 0 1 17.5 11h-2A2.5 2.5 0 0 1 13 8.5v-2Z" />
        <path d="M4 15.5A2.5 2.5 0 0 1 6.5 13h2A2.5 2.5 0 0 1 11 15.5v2A2.5 2.5 0 0 1 8.5 20h-2A2.5 2.5 0 0 1 4 17.5v-2Z" />
        <path d="M13 15.5A2.5 2.5 0 0 1 15.5 13h2A2.5 2.5 0 0 1 20 15.5v2A2.5 2.5 0 0 1 17.5 20h-2A2.5 2.5 0 0 1 13 17.5v-2Z" />
      </svg>
    ),
  },
  {
    label: "Tags",
    to: "/admin/tags",
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20.59 13.41 11.4 22.6a2 2 0 0 1-2.83 0L3 17.03V6a2 2 0 0 1 2-2h11.03l4.56 4.56a2 2 0 0 1 0 2.85Z" />
        <circle cx="7.5" cy="7.5" r="1.5" />
      </svg>
    ),
  },
  {
    label: "Comments",
    to: "/admin/comments",
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 15a3 3 0 0 1-3 3H8l-5 3V6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3Z" />
      </svg>
    ),
  },
  {
    label: "Users",
    to: "/admin/users",
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="11" cy="7" r="4" />
        <path d="M23 21v-2a3.5 3.5 0 0 0-3-3.45" />
        <path d="M16 3.5a4 4 0 0 1 0 7.75" />
      </svg>
    ),
  },
];

const Sidebar = ({ drawerWidth = 260, isRail = false, onClose = () => {} }) => {
  const handleLinkClick = () => {
    if (typeof window !== "undefined" && window.innerWidth < 900) onClose();
  };

  return (
    <>
      <style>{CSS}</style>

      <aside
        className={`sb-root ${isRail ? "sb-root--rail" : ""}`}
        style={{ width: drawerWidth }}
        aria-label="Admin sidebar"
      >
        <div className="sb-brand">
          <div className="sb-brand__logo" aria-hidden="true">
            N
          </div>

          <div className="sb-brand__text">
            <div className="sb-brand__name">24News</div>
            <div className="sb-brand__sub">Admin Panel</div>
          </div>

          <button
            type="button"
            className="sb-brand__collapse"
            aria-label={isRail ? "Expand sidebar" : "Collapse sidebar"}
            title={isRail ? "Expand sidebar" : "Collapse sidebar"}
            onClick={() => onClose()}
          >
            <span />
          </button>
        </div>

        <div className="sb-scroll">
          <div className="sb-section">
            <div className="sb-section__title">Navigation</div>

            <nav className="sb-nav">
              {NAV_ITEMS.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.end}
                  onClick={handleLinkClick}
                  className={({ isActive }) =>
                    `sb-link${isActive ? " sb-link--active" : ""}`
                  }
                  title={isRail ? item.label : undefined}
                >
                  <span className="sb-link__bar" />
                  <span className="sb-link__icon">{item.icon}</span>
                  <span className="sb-link__text">{item.label}</span>
                  <span className="sb-link__dot" aria-hidden="true" />
                </NavLink>
              ))}
            </nav>
          </div>

          <div className="sb-section">
            <div className="sb-section__title">Quick Links</div>

            <a
              href="/"
              className="sb-link sb-link--external"
              target="_blank"
              rel="noreferrer"
              title={isRail ? "View Site" : undefined}
            >
              <span className="sb-link__bar" />
              <span className="sb-link__icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                  <polyline points="15 3 21 3 21 9" />
                  <line x1="10" y1="14" x2="21" y2="3" />
                </svg>
              </span>
              <span className="sb-link__text">View Site</span>
              <span className="sb-link__dot" aria-hidden="true" />
            </a>
          </div>
        </div>

        <div className="sb-footer">
          <div className="sb-footer__version">v2.0.0</div>
          <div className="sb-footer__copy">
            <span className="sb-footer__mini">24News</span>
            <span className="sb-footer__mini sb-footer__mini--muted">Admin Console</span>
          </div>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;

const CSS = `
.sb-root{
  position:fixed;
  top:0;left:0;bottom:0;
  z-index:1200;
  display:flex;
  flex-direction:column;
  overflow:hidden;
  background:
    radial-gradient(circle at top, rgba(230,51,17,.12), transparent 35%),
    linear-gradient(180deg, #0f1117 0%, #0d0f14 100%);
  color:#f0f0f5;
  box-shadow:4px 0 32px rgba(0,0,0,.35);
  transition:width .28s cubic-bezier(.4,0,.2,1), transform .28s cubic-bezier(.4,0,.2,1);
  border-right:1px solid rgba(255,255,255,.05);
}
.sb-root::before{
  content:'';
  position:absolute;
  top:0;left:0;right:0;
  height:2px;
  background:linear-gradient(90deg, #e63311, rgba(230,51,17,.35), transparent);
}
.sb-root--rail{
  box-shadow:2px 0 18px rgba(0,0,0,.25);
}
.sb-root--rail .sb-brand__text,
.sb-root--rail .sb-section__title,
.sb-root--rail .sb-link__text,
.sb-root--rail .sb-footer__copy,
.sb-root--rail .sb-footer__version{
  opacity:0;
  transform:translateX(-6px);
  pointer-events:none;
}
.sb-root--rail .sb-link{
  justify-content:center;
  padding:0;
}
.sb-root--rail .sb-link__bar,
.sb-root--rail .sb-link__dot,
.sb-root--rail .sb-brand__collapse{
  display:none;
}
.sb-root--rail .sb-link__icon{
  margin-left:0;
}

.sb-brand{
  position:relative;
  display:flex;
  align-items:center;
  gap:12px;
  height:64px;
  padding:0 16px;
  border-bottom:1px solid rgba(255,255,255,.06);
  flex-shrink:0;
}
.sb-brand__logo{
  width:36px;
  height:36px;
  border-radius:11px;
  display:flex;
  align-items:center;
  justify-content:center;
  background:linear-gradient(135deg, #ff5c33 0%, #e63311 100%);
  color:#fff;
  font-weight:800;
  font-size:14px;
  letter-spacing:-.04em;
  box-shadow:0 0 0 1px rgba(230,51,17,.3), 0 10px 20px rgba(230,51,17,.16);
  flex-shrink:0;
}
.sb-brand__text{
  min-width:0;
  transition:opacity .2s ease, transform .2s ease;
}
.sb-brand__name{
  font-size:16px;
  font-weight:800;
  line-height:1;
  letter-spacing:-.03em;
}
.sb-brand__sub{
  margin-top:4px;
  font-size:10px;
  text-transform:uppercase;
  letter-spacing:.16em;
  color:rgba(240,240,245,.45);
  font-weight:700;
}
.sb-brand__collapse{
  position:absolute;
  right:-12px;
  top:50%;
  transform:translateY(-50%);
  width:24px;
  height:24px;
  border-radius:999px;
  border:1px solid rgba(255,255,255,.08);
  background:#171a23;
  cursor:pointer;
  display:flex;
  align-items:center;
  justify-content:center;
  color:rgba(240,240,245,.75);
  box-shadow:0 2px 10px rgba(0,0,0,.28);
}
.sb-brand__collapse span{
  width:8px;
  height:8px;
  border-right:2px solid currentColor;
  border-bottom:2px solid currentColor;
  transform:rotate(-45deg);
  margin-left:2px;
}
.sb-brand__collapse:hover{
  background:#e63311;
  color:#fff;
  border-color:#e63311;
}

.sb-scroll{
  flex:1;
  overflow-y:auto;
  overflow-x:hidden;
  padding:12px 10px 10px;
  scrollbar-width:thin;
  scrollbar-color:rgba(255,255,255,.10) transparent;
}
.sb-scroll::-webkit-scrollbar{width:4px;}
.sb-scroll::-webkit-scrollbar-track{background:transparent;}
.sb-scroll::-webkit-scrollbar-thumb{background:rgba(255,255,255,.10);border-radius:99px;}

.sb-section{
  margin-bottom:18px;
}
.sb-section__title{
  padding:12px 12px 8px;
  font-size:9px;
  font-weight:800;
  letter-spacing:.16em;
  text-transform:uppercase;
  color:rgba(240,240,245,.35);
  transition:opacity .2s ease, transform .2s ease;
}

.sb-nav{
  display:flex;
  flex-direction:column;
  gap:4px;
}

.sb-link{
  position:relative;
  display:flex;
  align-items:center;
  gap:12px;
  min-height:44px;
  padding:0 12px 0 14px;
  border-radius:14px;
  color:rgba(240,240,245,.72);
  text-decoration:none;
  transition:background .16s ease, color .16s ease, transform .16s ease, box-shadow .16s ease;
  outline:none;
}
.sb-link:hover{
  background:rgba(255,255,255,.04);
  color:#fff;
  transform:translateX(1px);
}
.sb-link:focus-visible{
  box-shadow:0 0 0 3px rgba(230,51,17,.2);
}
.sb-link__bar{
  position:absolute;
  left:0;
  top:9px;
  bottom:9px;
  width:3px;
  border-radius:999px;
  background:transparent;
  transition:background .16s ease, box-shadow .16s ease;
}
.sb-link__icon{
  width:20px;
  height:20px;
  flex-shrink:0;
  display:flex;
  align-items:center;
  justify-content:center;
  color:rgba(240,240,245,.72);
  transition:color .16s ease, transform .16s ease;
}
.sb-link__text{
  font-size:13px;
  font-weight:700;
  letter-spacing:-.01em;
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
  transition:opacity .2s ease, transform .2s ease;
}
.sb-link__dot{
  width:6px;
  height:6px;
  border-radius:999px;
  margin-left:auto;
  background:transparent;
  box-shadow:none;
  transition:background .16s ease, box-shadow .16s ease;
}
.sb-link--active{
  background:linear-gradient(135deg, rgba(230,51,17,.18) 0%, rgba(230,51,17,.08) 100%);
  color:#fff;
  box-shadow:inset 0 0 0 1px rgba(230,51,17,.12);
}
.sb-link--active .sb-link__bar{
  background:#e63311;
  box-shadow:0 0 10px rgba(230,51,17,.28);
}
.sb-link--active .sb-link__icon{
  color:#fff;
}
.sb-link--active .sb-link__dot{
  background:#ff6b47;
  box-shadow:0 0 0 3px rgba(230,51,17,.18);
}
.sb-link--external{
  margin-top:2px;
}

.sb-footer{
  flex-shrink:0;
  border-top:1px solid rgba(255,255,255,.06);
  padding:12px 12px 14px;
}
.sb-footer__version{
  font-size:11px;
  font-weight:700;
  color:rgba(240,240,245,.40);
  transition:opacity .2s ease, transform .2s ease;
}
.sb-footer__copy{
  margin-top:10px;
  display:flex;
  justify-content:space-between;
  align-items:center;
  gap:10px;
  transition:opacity .2s ease, transform .2s ease;
}
.sb-footer__mini{
  font-size:10px;
  font-weight:700;
  letter-spacing:.08em;
  text-transform:uppercase;
}
.sb-footer__mini--muted{
  color:rgba(240,240,245,.28);
}

@media (prefers-reduced-motion: reduce){
  .sb-root, .sb-link, .sb-brand__text, .sb-section__title, .sb-link__text, .sb-footer__copy, .sb-footer__version{
    transition:none !important;
  }
}
`;